import {useCallback, useEffect, useState} from "react";

import {getGuests, getMeasurementsAdmin} from "../api";

type UseMeasurementManagementDataProps = {
  userToken: string;
};

export const useMeasurementManagementData = ({userToken}: UseMeasurementManagementDataProps) => {
  const [measurements, setMeasurements] = useState([]);
  const [guests, setGuests] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const tempMeasurements = await getMeasurementsAdmin(userToken);
      const tempGuests = await getGuests(userToken);
      setMeasurements(tempMeasurements);
      setGuests(tempGuests);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [userToken]);

  useEffect(() => {
    if (userToken) {
      refresh();
    }
  }, [userToken, refresh]);

  return {
    measurements,
    guests,
    loading,
    refresh,
  };
};
